import { T_Filial } from "@/types/Busness"
import { FormControl, Select } from "@chakra-ui/react"
import { FunctionComponent } from "react"
import { UseFormSetValue } from "react-hook-form"

interface ISelect {
    data: T_Filial[],
    setValue: UseFormSetValue<any>
}

export const Selecter: FunctionComponent<ISelect> = ({
    data,
    setValue
}) => {
    return (
        <>
        {data?.length > 1 && (
          <FormControl sx={{ width: "100%" }}>
            <Select
              onChange={(value) => setValue("filial", value.target.value)}
              sx={{
                color: "rgba(0, 0, 0, 0.7)",
                bg: "#fff",
              }}
              placeholder="Selecione uma filial"
            >
              {data
                ?.filter(
                  (filial: T_Filial & { ativo: boolean }) => filial?.ativo
                )
                .map((filial: T_Filial & { ativo: boolean }) => (
                  <option
                    key={String(filial?.id)}
                    value={String(filial?.codfilial)}
                  >
                    {filial?.nomefilial}
                  </option>
                ))}
            </Select>
          </FormControl>
        )}
        </>
    )
}